<script setup>
//import { renderRichText } from '@storyblok/richtext'

const props = defineProps({ blok: Object, slug: String })

// ✅ Safe renderRichText mit Error-Handling
const copy = computed(() => {
  if (!props.blok?.copy) return ''
  
  try {
    // Prüfe ob renderRichText verfügbar ist
    if (typeof renderRichText === 'function') {
      return props.blok.copy;//renderRichText(props.blok.copy)
    } else {
      // Fallback: Verwende die copy direkt als String oder extrahiere Text
      return extractPlainText(props.blok.copy)
    }
  } catch (error) {
    console.warn('RenderRichText error:', error)
    // Fallback für den Fall eines Fehlers
    return extractPlainText(props.blok.copy)
  }
})

// Hilfsfunktion um Plain Text aus Rich Text zu extrahieren
function extractPlainText(richTextContent) {
  if (!richTextContent) return ''
  
  if (typeof richTextContent === 'string') {
    return richTextContent
  }
  
  if (richTextContent.content && Array.isArray(richTextContent.content)) {
    return richTextContent.content
      .map(node => {
        if (node.type === 'paragraph' && node.content) {
          return node.content
            .map(textNode => textNode.text || '')
            .join('')
        }
        return ''
      })
      .join(' ')
  }
  
  return ''
}
</script>

<template>
  <div class="break-inside group pb-6">
    <NuxtLink :to="slug">
      <figure class="overflow-hidden bg-no-repeat rounded-3xl bg-cover">
        <img 
          v-if="blok.image?.filename" 
          loading="lazy"
          :width="375"
          class="rounded-3xl bg-orange-400 w-full group-hover:scale-110 transition duration-300 ease-in-out" 
          :alt="blok.image.alt" 
          :src="blok.image.filename + '/m/375x0'" 
        />
        <div v-else class="bg-orange-200 w-full rounded-3xl aspect-square"></div>
      </figure>
    </NuxtLink>	
    
    <PostCategories :blok="blok.categories" />

    <NuxtLink :to="slug">
      <h3 class="text-xl md:text-2xl mt-4 font-bold hover:text-primary-100 transition-colors duration-300 ease-in-out">
        {{ blok.title }}
      </h3>
    </NuxtLink>
    
    <!-- ✅ Verwende v-if um sicherzustellen, dass copy existiert -->
    <div 
      v-if="copy" 
      class="text-lg md:text-xl mt-4 font-thin" 
      v-html="copy"
    ></div>
  </div>
</template>